/* Find Deals screen */
import React, { Component, Suspense } from "react";
import axios from "../../axios";
import "../../brands/common/css/common.scss";
import Footer from "../../components/Common/Footer";
import _ from "lodash";
const root = document.documentElement;
root?.style.setProperty(
    "--background-color",
    sessionStorage.getItem("background-color")
);
root?.style.setProperty(
    "--modal-background-color",
    sessionStorage.getItem("modal-background-color")
);
root?.style.setProperty(
    "--primary-text-color",
    sessionStorage.getItem("primary-text-color")
);
root?.style.setProperty(
    "--primary-color",
    sessionStorage.getItem("base-color")
);
root?.style.setProperty(
    "--secondary-color",
    sessionStorage.getItem("secondary-color")
);
root?.style.setProperty(
    "--secondary-text-color",
    sessionStorage.getItem("secondary-text-color")
);
root?.style.setProperty(
    "--border-color",
    sessionStorage.getItem("border-color")
);
root?.style.setProperty(
    "--primary-color-rgb",
    sessionStorage.getItem("base-color-rgb")
);
root?.style.setProperty("--link-color", sessionStorage.getItem("link-color"));
root?.style.setProperty(
    "--button-color",
    sessionStorage.getItem("button-color")
);
root?.style.setProperty("--button-text-color", "#FFF");
root?.style.setProperty(
    "--banner-color-1",
    sessionStorage.getItem("banner-color-1")
);
root?.style.setProperty(
    "--banner-color-2",
    sessionStorage.getItem("banner-color-2")
);
class SelectPlan extends Component {
    constructor(props) {
        super(props);
        this.state = {
            planList: [],
            loading: false,
            SelectPlanComponent: null,
        };
    }
    componentDidMount() {
        this.loadSelectPlanComponent();
        this.getPlans();
        this.setSessionStorage();
        // Extract returnUrl from query parameters
        const urlParams = new URLSearchParams(window.location.search);
        console.log(urlParams.get('returnUrl'));
        const linkingUri = urlParams.get('returnUrl') || urlParams.get('linkingUri');
        if (linkingUri) {
            sessionStorage.setItem("linkingUri", linkingUri);
        }
    }
    componentDidUpdate(prevProps) {
        // If customBrand prop changed and we don't have a component yet, try to load it
        if (prevProps.customBrand !== this.props.customBrand && this.props.customBrand && !this.state.SelectPlanComponent) {
            this.loadSelectPlanComponent();
        }
    }
    loadSelectPlanComponent = () => {
        const customBrand = this.props.customBrand || sessionStorage.getItem("customBrand");
        if (customBrand) {
            const SelectPlanComponent = React.lazy(() =>
                import(
                    "../../brands/" +
                        customBrand +
                        "/components/Upgrade/SelectPlan"
                )
            );
            this.setState({ SelectPlanComponent });
        } else {
            // Retry after a short delay if customBrand is not available yet
            setTimeout(this.loadSelectPlanComponent, 100);
        }
    };
    getPlans = () => {
        this.setState({
            loading: true,
        });
        let body;
        if (sessionStorage.getItem("unit")) {
          body = {
            AccessToken: sessionStorage.getItem("AccessToken"),
            UnitID_internal: sessionStorage.getItem("unit"),
            // ShoppingCartEnabled: true,
          };
        } else {
          // body = {
          //   VenueID: sessionStorage.getItem("venueID"),
          //   ShoppingCartEnabled: true,
          // };
          setTimeout(this.getPlans, 100);
        }
        // body = {
        //     VenueID: sessionStorage.getItem("venueID"),
        //     ShoppingCartEnabled: true,
        // };
        // console.log(sessionStorage.getItem("unit"))
        let filteredServicePlans = [];
        axios
            .post(
                "/networkoperatorconsole/shoppingcart/listServicePlans",
                body,
                {
                    headers: {},
                }
            )
            .then((response) => {
             sessionStorage.setItem(
                "currencyNames", response.data["AvailableServicePlans"][0].Currencies[0])
                for (
                    var i = 0;
                    i < response.data["AvailableServicePlans"].length;
                    i++
                ) {
                 if (
                response.data["AvailableServicePlans"][i][
                    "BillingCycleHours"
                ] === parseFloat(sessionStorage.getItem("billingCycleHours")) &&
                response.data["AvailableServicePlans"][i][
                    "ServicePlanID"
                ] !== sessionStorage.getItem("servicePlanIDSubscriber") &&
                response.data["AvailableServicePlans"][i][
                    "DownloadKbps"
                ] > 10000 &&
                response.data["AvailableServicePlans"][i]["ServicePlanDescription"].toLowerCase()
                    .search("bulk") < 0 &&
                    response.data["AvailableServicePlans"][i]["ServicePlanID"] !== sessionStorage.getItem("servicePlanID")) {
                    filteredServicePlans.push(
                        response.data["AvailableServicePlans"][i]
                    );
                   }
                }
                // const firstCurrencyValue = JSON.parse(sessionStorage.getItem("currencyNames"))[0];
                let sortedServicePlans = _(filteredServicePlans)
                    .map(function (v, k) {
                        return _.merge({}, v, { key: k });
                    })
                    .sortBy("BillingCyclePrice." + response.data["AvailableServicePlans"][0].Currencies)
                    .reverse() // sort by name
                    .value();
                console.log(sortedServicePlans)
                this.setState({
                    planList: sortedServicePlans,
                });
                this.setState({
                    loading: false,
                });
            })
            .catch((error) => {
                this.setState({
                    loading: false,
                });
                this.setState({ error: true });
            });
    };
    selectedPlan = (
        servicePlanKey,
        servicePlanID,
        stripePriceID,
        servicePlanName,
        billingCyclePrice,
        billingCycleRecurrence,
        fixedBillingDate,
        trialCycles
    ) => {
        sessionStorage.setItem("servicePlanKey", servicePlanKey);
        sessionStorage.setItem("servicePlanID", servicePlanID);
        sessionStorage.setItem("stripePriceID", stripePriceID);
        sessionStorage.setItem("servicePlanName", servicePlanName);
        sessionStorage.setItem("billingCyclePrice", billingCyclePrice);
        sessionStorage.setItem("servicePlanPriceSubscriber", billingCyclePrice);
        sessionStorage.setItem(
            "billingCycleRecurrence",
            billingCycleRecurrence
        );
        sessionStorage.setItem("fixedBillingDate", fixedBillingDate);
        sessionStorage.setItem("trialCycles", trialCycles);
    };
    setSessionStorage = () => {
        const urlParams = new URLSearchParams(window.location.search);
        console.log('Processing URL parameters for session storage...');
        for (const [key, value] of urlParams.entries()) {
            if (key.startsWith('ss_')) {
                // Remove the 'ss_' prefix to get the actual session storage key
                const sessionKey = key.substring(3);
                // Store in session storage
                sessionStorage.setItem(sessionKey, value);
                console.log(`Stored in session storage: ${sessionKey} = ${value}`);
            }
        }
    };
    render() {
        const { SelectPlanComponent } = this.state;
        return (
            <>
                <Suspense
                    fallback={
                        <div
                            className="overlay"
                            id="overlay"
                            style={{ display: "block" }}
                        >
                            <div className="overlayMessage">
                                <div
                                    className="spinner-border spinner-border"
                                    role="status"
                                >
                                    <span className="sr-only">Loading...</span>
                                </div>
                            </div>
                        </div>
                    }
                >
                    {SelectPlanComponent && (
                        <SelectPlanComponent
                            planList={this.state.planList}
                            loading={this.state.loading}
                            selectedPlan={this.selectedPlan}
                            logo={this.props.logoLogin}
                            brand={this.props.brand}
                        />
                    )}
                    <Footer />
                </Suspense>
            </>
        );
    }
}
export default SelectPlan;
